export const ru = {
    'button-cancel': 'Отмена'
};
